module.exports = __webpack_public_path__ + "static/img/yytx41.0b4685e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/yytx41.png
// module id = 819
// module chunks = 0